const state = {
  benefits: [],
  benefit: {},
  sections: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  section: {},
  stores: {
    isLoading: false,
    content: [],
    pagination: {},
  },
  keywordBenefit: {
    deviceIdx: '',
    deviceName: '',
    factoryPrice: '',
    keywordBenefitId: 0,
    keywordId: 0,
    manufacturerId: '',
    manufacturerName: '',
    modelName: '',
    period: '', //DAY_7 DAY_30
    storeId: 0,
  },
  storeKeyword: {},
};

export default state;
